import React from 'react';

const VideoBanner = (props) => {
    const { idVideo } = props;
    return (
        <iframe
            src={`https://www.youtube.com/embed/${idVideo}?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=0&autoplay=1&loop=1&playlist=${idVideo}`}
            className="w-full h-full" frameBorder="0" >
        </iframe>
    );
}

export default VideoBanner;